<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeForm"
    :title="rowInfo.id===''?'添加企业':'编辑企业'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="cusName">
              <el-input v-model="rowInfo.cusName" placeholder="企业名称" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业简称">
              <el-input v-model="rowInfo.cusShortName" placeholder="企业简称" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业logo">
               <img-upload
                 v-model="rowInfo.cusLogoAttachmentId"
                 :url="rowInfo.cusLogoUrl"
               />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办公地址">
              <el-input v-model="rowInfo.address" placeholder="办公地址" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业负责人">
              <el-input v-model="rowInfo.cusHead" placeholder="企业负责人" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属项目" prop="projectId">
              <select-text v-model="rowInfo.projectId" :multiple="true" code-set-id="" :options="projectOptions"  placeholder="所属项目" style="width: 220px;"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="cusPhone">
              <el-input v-model="rowInfo.cusPhone" placeholder="联系电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="联系邮箱" prop="cusEmail">
              <el-input v-model="rowInfo.cusEmail" placeholder="联系邮箱" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="预存金额" prop="budgeLimit">
                <el-input v-model="rowInfo.budgeLimit" type="number" placeholder="预存金额" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="透支额度" prop="creditLine">
                <el-input v-model="rowInfo.creditLine" type="number" placeholder="透支额度" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="已使用总金额" prop="budgeUsed">
                <el-input v-model="rowInfo.budgeUsed" type="number" :disabled="true" placeholder="已使用总金额" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="rowInfo.id !=''" style="display: flex;position: relative;left: 16px;">
               <el-date-picker
                 v-model="selectDate"
                 type="date"
                 placeholder="请选择日期"
                 value-format="yyyy-MM-dd"
                 style="width: 180px">
            </el-date-picker>
            <el-button type="primary" size="small"
                       round icon="el-icon-refresh-right"
                       @click="resetBudgeLimit"
                      style="margin-left: 10px;">重置已使用金额</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div>
              <span>
                线下使用总金额
              </span>
            </div>
            <el-form-item prop="offlineUsed">
                <el-input v-model="rowInfo.offlineUsed" type="number" :disabled="true" placeholder="线下使用总金额" style="position: relative;top: -25px;left:10px;width: 210px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <div>
              <span>
                线下本次使用金额
              </span>
            </div>
            <el-form-item prop="offlineCurrentUsed">
              <el-input v-model="rowInfo.offlineCurrentUsed" type="number" placeholder="线下本次使用金额" style="position: relative;top: -25px;left:25px;width: 195px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import ImgUpload from '@/components/ImgUpload/index.vue'
import { addListpage,getDynamicFormValue} from  "@/api/cus/cusinfo"
import { updateSettledFlagByDate } from "@/api/order/orderinfo"
import { mapGetters } from 'vuex';
import {loadProjectList} from "@/api/project";
import SelectText from "@/components/SelectText";
export default {
  components: {
    ImgUpload,SelectText
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    // 手机号
    let validatePhone = (rule, value, callback) => {
      let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的电话'))
      }
      callback()
    }
    let validateEmail = (rule, value, callback) => {
      let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      }
      callback()
    }
    return {
      visible: false,
      formName: '新增',
      uploadUrl: process.env.VUE_APP_BASE_API + '/attach/upload',
      loading: false,
      selectDate:'',
      projectOptions:[],
      rowInfo: {
        id: '',
        cusName: '',
        cusShortName: '',
        address: '',
        cusHead: '',
        cusLogoAttachmentId: '',
        cusPhone: '',
        cusEmail: '',
        budgeLimit:null,//预存金额
        budgeUsed:null,//已使用额度
        creditLine:null,//透支额度
        offlineUsed:null,//线下使用额度
        offlineCurrentUsed:null,//线下使用额度
        cusLogoUrL: '',
        projectId:[],
        status: 1,
        remark: '',
      },
      rules: {
        cusName: [{ required: true, message: '必填:企业名称', trigger: 'blur' }],
        cusPhone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        cusEmail: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        budgeLimit: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        creditLine:[
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        offlineCurrentUsed:[
          {
            // pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            pattern: /^(\-)?\d+(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
      }
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.visible = true
      this.rowInfo.id = id
      if (id) {
        getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
            }
        })
      }
      this.loadProjectList()
    },
    loadProjectList(){
      loadProjectList().then(res => {
        this.projectOptions = res.data.data
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addListpage(this.rowInfo).then((res) => {
            if (res.data.code==0) {
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },

    //重置额度
    resetBudgeLimit(){
      console.log(this.selectDate);
      if(this.selectDate === "" || this.selectDate === null){
        this.$message.warning("请选择日期");
      }else {
        this.$confirm('您确定要将' + this.rowInfo.cusName + '客户' + this.selectDate + '前的订单清零?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //重置额度：将该时间之前的所有订单(用车时间)的标识更新为:客户已结款
          updateSettledFlagByDate({"cusId": this.rowInfo.id, "date": this.selectDate}).then(res => {
            if(res.data.code==0 && res.data.data ){
                this.$message.success("重置已使用金额成功");
                this.init(this.rowInfo.id);
            }else{
              this.$message.error("重置已使用金额失败")
            }
          })
        }).catch(() => {
        })
      }
    },

    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields();
      this.selectDate = '';
      this.rowInfo = {
        id: '',
        cusName: '',
        cusShortName: '',
        address: '',
        cusHead: '',
        cusLogoAttachmentId: '',
        cusPhone: '',
        cusEmail: '',
        budgeLimit:null,//预算额度
        budgeUsed:null,//已使用额度
        creditLine:null,//透支额度
        offlineUsed:null,//线下使用额度
        offlineCurrentUsed:null,//线下本次已使用额度
        cusLogoUrL: '',
        status: 1,
        remark: ''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
